(function () {
var wrap = document.getElementById('version-wrap');
var tag  = document.getElementById('version-tag');
if (!wrap || !tag) return;
function toggle() {
var open = wrap.hasAttribute('data-open');
if (open) {
wrap.removeAttribute('data-open');
tag.setAttribute('aria-expanded', 'false');
} else {
wrap.setAttribute('data-open', '');
tag.setAttribute('aria-expanded', 'true');
}
}
tag.addEventListener('click', function (e) {
e.stopPropagation();
toggle();
});
var subToggles = document.querySelectorAll('[data-vd-toggle]');
subToggles.forEach(function (btn) {
btn.addEventListener('click', function (e) {
e.stopPropagation();
var item = btn.closest('.vd-item');
if (!item) return;
var expanded = item.hasAttribute('data-expanded');
if (expanded) {
item.removeAttribute('data-expanded');
btn.setAttribute('aria-expanded', 'false');
} else {
item.setAttribute('data-expanded', '');
btn.setAttribute('aria-expanded', 'true');
}
});
});
document.addEventListener('click', function (e) {
if (!wrap.hasAttribute('data-open')) return;
if (!wrap.contains(e.target)) {
wrap.removeAttribute('data-open');
tag.setAttribute('aria-expanded', 'false');
}
});
document.addEventListener('keydown', function (e) {
if (e.key === 'Escape' && wrap.hasAttribute('data-open')) {
wrap.removeAttribute('data-open');
tag.setAttribute('aria-expanded', 'false');
}
});
})();
(function () {
var wrap   = document.getElementById('input-wrap');
var cycle  = document.getElementById('input-cycle');
var input  = document.getElementById('signup-email');
if (!wrap || !cycle || !input) return;
var phrases = [
'Enter your Email Address',
'Be the First to Know',
'Unlock Rewards and Discounts'
];
var idx = 0;
var timer = null;
function tick() {
if (document.activeElement === input || input.value.length > 0) return;
wrap.classList.add('fading');
setTimeout(function () {
idx = (idx + 1) % phrases.length;
cycle.textContent = phrases[idx];
wrap.classList.remove('fading');
}, 380);
}
timer = setInterval(tick, 3200);
input.addEventListener('focus', function () { wrap.classList.add('focused'); });
input.addEventListener('blur',  function () { if (!input.value) wrap.classList.remove('focused'); });
input.addEventListener('input', function () {
if (input.value) wrap.classList.add('filled');
else wrap.classList.remove('filled');
});
window.__stopCycle = function () { if (timer) { clearInterval(timer); timer = null; } };
})();
var wisdomDeck = [
{ name: 'Ashwagandha',   text: 'From the Sanskrit "smell of horse" — its root carries an earthy aroma. Ayurvedic practitioners have used it for over three thousand years.' },
{ name: 'Reishi',        text: 'Known as "lingzhi" in Chinese — "the herb of spiritual potency." Cultivated across Asia for more than two thousand years.' },
{ name: 'Lion’s Mane',  text: 'Grows on hardwood trees in cascading white tendrils. Found wild in temperate forests across North America, Europe, and Asia.' },
{ name: 'Tongkat Ali',   text: 'Eurycoma longifolia takes four or more years to mature before its roots are harvested from Malaysian and Indonesian forests.' },
{ name: 'Cordyceps',     text: 'Native to the high Tibetan plateau, traditionally found at elevations above ten thousand feet. Modern cultivation now produces sustainable strains.' },
{ name: 'Tulsi',         text: 'Holy basil — sacred in Hindu tradition. Many homes still grow a Tulsi plant near the door for daily devotion.' },
{ name: 'Pine Pollen',   text: 'Contains all nine essential amino acids. Harvested briefly each spring when male pine cones release their pollen on the wind.' },
{ name: 'Chaga',         text: 'Grows on birch trees in cold northern climates. A single conk can take ten to twenty years to fully mature on its host tree.' }
];
var wisdomIdx = 0;
function showWisdom(animate) {
var card    = document.getElementById('wisdom-card');
var name    = document.getElementById('wisdom-name');
var text    = document.getElementById('wisdom-text');
var eyebrow = document.getElementById('wisdom-eyebrow');
if (!card || !name || !text || !eyebrow) return;
var apply = function () {
var c = wisdomDeck[wisdomIdx];
name.textContent = c.name;
text.textContent = c.text;
var num = String(wisdomIdx + 1).padStart(2, '0');
eyebrow.textContent = 'Card ' + num + ' · Apothecary Lore';
};
if (animate) {
card.classList.add('flipping');
setTimeout(function () {
apply();
card.classList.remove('flipping');
}, 340);
} else {
apply();
}
}
function peakSignup(e) {
e.preventDefault();
var input = document.getElementById('signup-email');
if (input && (!input.value || !input.value.includes('@'))) return false;
if (window.__stopCycle) window.__stopCycle();
var signup = document.getElementById('signup-area');
var wisdom = document.getElementById('wisdom-area');
if (signup) {
signup.style.transition = 'opacity 320ms ease, transform 320ms ease';
signup.style.opacity = '0';
signup.style.transform = 'translateY(-6px)';
setTimeout(function () {
signup.style.display = 'none';
if (wisdom) {
wisdom.style.display = 'block';
requestAnimationFrame(function () { wisdom.classList.add('show'); });
}
wisdomIdx = Math.floor(Math.random() * wisdomDeck.length);
showWisdom(false);
}, 320);
}
return false;
}
function bloomSignup(e) {
e.preventDefault();
var btn = e.target.querySelector('button');
btn.innerText = 'In';
btn.disabled = true;
return false;
}
document.addEventListener('DOMContentLoaded', function () {
var draw = document.getElementById('wisdom-draw');
if (!draw) return;
draw.addEventListener('click', function () {
var next;
do { next = Math.floor(Math.random() * wisdomDeck.length); }
while (next === wisdomIdx && wisdomDeck.length > 1);
wisdomIdx = next;
showWisdom(true);
});
});
(function () {
var root      = document.getElementById('bloom');
var openBt    = document.getElementById('bloom-open');
var closeBt   = document.getElementById('bloom-close');
var play      = document.getElementById('bloom-play');
var prevBt    = document.getElementById('bloom-prev');
var nextBt    = document.getElementById('bloom-next');
var trackEl   = document.getElementById('bloom-track');
var audioA    = document.getElementById('bloom-audio-a');
var audioB    = document.getElementById('bloom-audio-b');
var vol       = document.getElementById('bloom-vol');
var prog      = document.getElementById('bloom-progress');
var fill      = document.getElementById('bloom-progress-fill');
var cur       = document.getElementById('bloom-current');
var dur       = document.getElementById('bloom-duration');
if (!root || !audioA || !audioB) return;
var TRACK_URLS = window.PEAK_FM_TRACK_URLS || ['peak-fm-track-1.mp3', 'peak-fm-track-2.mp3'];
var TRACKS = [
{ name: 'Acoustic Chill', src: TRACK_URLS[0] },
{ name: 'Porch Guitar',   src: TRACK_URLS[1] }
];
var idx = 0;
function trackLabel(i) {
var n = String(i + 1).padStart(2, '0');
return 'Track ' + n + ' · ' + TRACKS[i].name;
}
function updateTrackLabel() {
if (trackEl) trackEl.textContent = trackLabel(idx);
}
updateTrackLabel();
var CROSSFADE_S = 3.0;    
var targetVol = parseFloat(vol.value) / 100;
var active = audioA;
var standby = audioB;
var playing = false;
var crossfading = false;
var rafId = null;
var monitorId = null;
audioA.volume = 0;
audioB.volume = 0;
function fmt(t) {
if (!isFinite(t)) return '0:00';
var m = Math.floor(t / 60), s = Math.floor(t % 60);
return m + ':' + (s < 10 ? '0' + s : s);
}
function setPlaying(on) {
if (on) root.setAttribute('data-playing', '');
else    root.removeAttribute('data-playing');
play.setAttribute('aria-label', on ? 'Pause' : 'Play');
}
function openCard()  { root.setAttribute('data-open', ''); }
function closeCard() { root.removeAttribute('data-open'); }
function startCrossfade() {
if (crossfading) return;
crossfading = true;
standby.currentTime = 0;
standby.volume = 0;
var p = standby.play();
if (p && p.catch) p.catch(function(){});
var startTs = performance.now();
var durMs = CROSSFADE_S * 1000;
var fromActive = active;
var fromStandby = standby;
function tick(ts) {
var elapsed = ts - startTs;
var t = Math.min(elapsed / durMs, 1);
var outGain = Math.cos(t * Math.PI / 2);
var inGain  = Math.sin(t * Math.PI / 2);
fromActive.volume  = targetVol * outGain;
fromStandby.volume = targetVol * inGain;
if (t < 1) {
rafId = requestAnimationFrame(tick);
} else {
fromActive.pause();
fromActive.currentTime = 0;
active  = fromStandby;
standby = fromActive;
crossfading = false;
}
}
rafId = requestAnimationFrame(tick);
}
function monitor() {
if (!playing) return;
if (active && isFinite(active.duration)) {
var remaining = active.duration - active.currentTime;
if (remaining > 0 && remaining <= CROSSFADE_S && !crossfading) {
startCrossfade();
}
}
monitorId = requestAnimationFrame(monitor);
}
function startPlayback() {
if (playing) return;
if (!isFinite(active.currentTime) || active.currentTime < 0) active.currentTime = 0;
active.volume = targetVol > 0 ? targetVol : 0.5;
var p = active.play();
if (p && p.then) {
p.then(function () {
playing = true;
setPlaying(true);
monitor();
}).catch(function (err) {
console.error('Peak FM play failed:', err && err.name, err && err.message);
});
} else {
playing = true;
setPlaying(true);
monitor();
}
}
function stopPlayback() {
playing = false;
setPlaying(false);
if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
if (monitorId) { cancelAnimationFrame(monitorId); monitorId = null; }
active.pause();
standby.pause();
crossfading = false;
}
openBt.addEventListener('click', function () {
openCard();
startPlayback();
});
closeBt.addEventListener('click', closeCard);
play.addEventListener('click', function () {
if (playing) stopPlayback();
else         startPlayback();
});
document.addEventListener('click', function (e) {
if (!root.hasAttribute('data-open')) return;
if (!root.contains(e.target)) closeCard();
});
document.addEventListener('keydown', function (e) {
if (e.key === 'Escape' && root.hasAttribute('data-open')) closeCard();
});
vol.addEventListener('input', function () {
targetVol = parseFloat(vol.value) / 100;
if (!crossfading) {
active.volume = targetVol;
}
});
function updateProgress() {
if (active && isFinite(active.duration)) {
var pct = (active.currentTime / active.duration) * 100;
fill.style.width = (isFinite(pct) ? pct : 0) + '%';
cur.innerText = fmt(active.currentTime);
}
requestAnimationFrame(updateProgress);
}
audioA.addEventListener('loadedmetadata', function () { dur.innerText = fmt(audioA.duration); });
requestAnimationFrame(updateProgress);
prog.addEventListener('click', function (e) {
var rect = prog.getBoundingClientRect();
var x = (e.clientX - rect.left) / rect.width;
if (active && isFinite(active.duration)) {
active.currentTime = Math.max(0, Math.min(1, x)) * active.duration;
}
});
function loadTrack(i) {
idx = (i + TRACKS.length) % TRACKS.length;
var newSrc = TRACKS[idx].src;
var wasPlaying = playing;
if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
if (monitorId) { cancelAnimationFrame(monitorId); monitorId = null; }
audioA.pause();
audioB.pause();
crossfading = false;
playing = false;
setPlaying(false);
audioA.src = newSrc;
audioB.src = newSrc;
audioA.load();
audioB.load();
active = audioA;
standby = audioB;
active.volume = 0;
standby.volume = 0;
updateTrackLabel();
fill.style.width = '0%';
cur.textContent = '0:00';
if (wasPlaying) {
var p = active.play();
if (p && p.then) p.then(function () {
active.volume = targetVol;
playing = true;
setPlaying(true);
monitor();
}).catch(function () {});
}
}
if (prevBt) prevBt.addEventListener('click', function () { loadTrack(idx - 1); });
if (nextBt) nextBt.addEventListener('click', function () { loadTrack(idx + 1); });
document.addEventListener('visibilitychange', function () {
if (document.hidden && playing) {
playing = false;
setPlaying(false);
if (rafId) cancelAnimationFrame(rafId);
if (monitorId) cancelAnimationFrame(monitorId);
active.pause();
standby.pause();
crossfading = false;
}
});
})();
(function () {
var btn = document.getElementById('bookmark-btn');
var modal = document.getElementById('bm-modal');
var body = document.getElementById('bm-modal-body');
if (!btn || !modal || !body) return;
function detectPlatform() {
var ua = navigator.userAgent || '';
var platform = navigator.platform || '';
var isIOS = /iPhone|iPad|iPod/.test(ua) || (/Mac/.test(platform) && navigator.maxTouchPoints > 1);
var isAndroid = /Android/.test(ua);
var isMobile = isIOS || isAndroid;
var isMac = !isMobile && /Mac/.test(platform);
return { isIOS: isIOS, isAndroid: isAndroid, isMobile: isMobile, isMac: isMac };
}
function renderSteps() {
var p = detectPlatform();
var html = '';
if (p.isIOS) {
html += '<div class="bm-step"><strong>iOS — Safari</strong>Tap the <strong style="display:inline; font-size:13px; color: var(--ink); letter-spacing:0; text-transform:none; margin:0;">share icon</strong> at the bottom of the screen, then choose <strong style="display:inline; font-size:13px; color: var(--ink); letter-spacing:0; text-transform:none; margin:0;">Add Bookmark</strong>. To put it on your home screen, choose <strong style="display:inline; font-size:13px; color: var(--ink); letter-spacing:0; text-transform:none; margin:0;">Add to Home Screen</strong>.</div>';
} else if (p.isAndroid) {
html += '<div class="bm-step"><strong>Android — Chrome</strong>Tap the <strong style="display:inline; font-size:13px; color: var(--ink); letter-spacing:0; text-transform:none; margin:0;">⋮ menu</strong> in the top-right, then tap the <strong style="display:inline; font-size:13px; color: var(--ink); letter-spacing:0; text-transform:none; margin:0;">☆ star icon</strong>. To put it on your home screen, tap <strong style="display:inline; font-size:13px; color: var(--ink); letter-spacing:0; text-transform:none; margin:0;">Add to Home screen</strong>.</div>';
} else {
var key = p.isMac ? '<kbd>⌘ D</kbd>' : '<kbd>Ctrl + D</kbd>';
html += '<div class="bm-step"><strong>' + (p.isMac ? 'Mac — Browser' : 'Desktop — Browser') + '</strong>Press ' + key + ' to bookmark this page.</div>';
html += '<div class="bm-step"><strong>Also works</strong>Press ' + (p.isMac ? '<kbd>⌘ Shift D</kbd>' : '<kbd>Ctrl + Shift + D</kbd>') + ' on Chrome / Edge to bookmark all open tabs into a folder.</div>';
}
body.innerHTML = html;
}
function open() {
renderSteps();
modal.hidden = false;
requestAnimationFrame(function () { modal.setAttribute('data-open', ''); });
}
function close() {
modal.removeAttribute('data-open');
setTimeout(function () { modal.hidden = true; }, 260);
}
btn.addEventListener('click', open);
modal.querySelectorAll('[data-bm-close]').forEach(function (el) {
el.addEventListener('click', close);
});
document.addEventListener('keydown', function (e) {
if (e.key === 'Escape' && !modal.hidden) close();
});
})();
(function () {
var btn = document.getElementById('share-btn');
if (!btn) return;
function showToast(text) {
var existing = document.querySelector('.bookmark-toast');
if (existing) existing.remove();
var toast = document.createElement('div');
toast.className = 'bookmark-toast';
toast.textContent = text;
document.body.appendChild(toast);
requestAnimationFrame(function () { toast.classList.add('show'); });
setTimeout(function () {
toast.classList.remove('show');
setTimeout(function () { toast.remove(); }, 320);
}, 2800);
}
btn.addEventListener('click', function () {
var data = {
title: 'Peak Herbs',
text: 'Peak Herbs — single-ingredient natural capsules. Opening soon.',
url: window.location.href
};
if (navigator.share) {
navigator.share(data).catch(function () {  });
return;
}
if (navigator.clipboard && navigator.clipboard.writeText) {
navigator.clipboard.writeText(window.location.href).then(function () {
showToast('Link copied');
}).catch(function () {
showToast(window.location.href);
});
} else {
showToast(window.location.href);
}
});
})();